<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Beszállítói megrendelések</span>
      <el-button
        style="float: right; margin-top: -5px;"
        type="success"
        size="small"
        @click="$router.replace('/processes/supplier-orders/add')"
        icon="el-icon-plus"
        v-can="'supplierorder.create'"
      >
        Új beszállítói megrendelés
      </el-button>
    </div>
    <div v-loading="loading" style="min-height: 81px;">
      <table-filter
        v-if="filterConfig"
        :config="filterConfig"
        action="supplierOrder/fetchAll"
      />
    </div>
    <supplier-order-list/>
    <template v-if="$route.meta.showAddSupplierOrderDialog">
      <supplier-order-dialog
        type="add"
        :supplierOrderId="$route.params.id"
      />
    </template>
    <template v-if="$route.meta.showUpdateSupplierOrderDialog">
      <supplier-order-dialog
        :supplierOrderId="$route.params.id"
        type="update"
      />
    </template>
    <template v-if="$route.meta.showSupplierViewOrderDialog">
      <supplier-order-dialog
        :supplierOrderId="$route.params.id"
        type="view"
      />
    </template>
  </el-card>
</template>

<script>
import SupplierOrderList from '../../components/processes/supplierOrders/List';
import SupplierOrderDialog from '../../components/processes/supplierOrders/Dialog';
import TableFilter from '../../components/TableFilter';

export default {
  components: {
    SupplierOrderList,
    SupplierOrderDialog,
    TableFilter,
  },
  data() {
    return {
      loading: false,
      filterConfig: null,
    };
  },
  async mounted() {
    this.loading = true;
    await this.setConfig();
    this.loading = false;
  },
  methods: {
    async setConfig() {
      let storages = this.$store.getters['storage/storages'];
      if (!storages.length) {
        await this.$store.dispatch('storage/fetchAll');
        storages = this.$store.getters['storage/storages'];
      }
      this.filterConfig = [
        {
          type: 'text',
          name: 'receipt_number',
          label: 'Bizonylatszám',
          defaultSearch: true,
        },
        {
          type: 'select',
          options: [
            {
              label: 'Bevételezett',
              status: 'done'
            },
            {
              label: 'Elküldve',
              status: 'sent'
            },
            {
              label: 'Rögzítve',
              status: 'recorded'
            },
            {
              label: 'Lemondva',
              status: 'cancelled'
            },
          ],
          name: 'status',
          label: 'Státusz',
          labelCallback: status => status.label,
          valueKey: 'status',
        },
        {
          type: 'remote',
          name: 'supplier_id',
          label: 'Beszállító',
          labelCallback: partner => partner && `#${partner.id} ${partner.company.name}` || '',
          valueKey: 'id',
          remoteSearchParam: 'name',
          remoteAction: 'partner/search',
        },
        {
          type: 'select',
          options: storages,
          name: 'storage_id',
          label: 'Raktár',
          labelCallback: storage => storage && storage.name || '',
          valueKey: 'id',
        },
      ];
    },
  },
};
</script>
